import type { MapSettingsToolsStateDataLayersAction } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.action';
import { activeDataLayersBTGIdPerBoundaryGroupChanged } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.actionCreators';
import type { MapSettingsToolsStateDataLayersState } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.state';

export const mapSettingsToolsStateDataLayersInitialState: MapSettingsToolsStateDataLayersState = {
  activeBTGIdPerBoundaryGroup: {},
};

type Action = MapSettingsToolsStateDataLayersAction;

export const mapSettingsToolsStateDataLayersReducer = (state = mapSettingsToolsStateDataLayersInitialState, action: Action): MapSettingsToolsStateDataLayersState => {
  if (activeDataLayersBTGIdPerBoundaryGroupChanged.match(action)) {
    const { boundaryGroupId, activeBTGId } = action.payload;

    return {
      ...state,
      activeBTGIdPerBoundaryGroup: {
        ...state.activeBTGIdPerBoundaryGroup,
        [boundaryGroupId]: activeBTGId,
      },
    };
  }

  return state;
};
